import React from 'react'
import { title } from './data'

export default function Title() {
    return (
        <div> {title}
        </div>
    )
}
